module.exports = __webpack_public_path__ + "b4ce3a5078f7fc98702f5e3ef816e134.png";